import { Module } from "vuex";
import { IActions, IGetters, IMutations, ICatalogState } from "./catalog.type";

export const getters: IGetters = {
    isLoading: (state) => {
        return state.loading;
    }
};

export const mutations: IMutations = {
    setLoading: (state, payload) => {
        state.loading = payload;
    },
};

export const actions: IActions = {
    // async fetchSale(this, context, payload): Promise<void> {
    //     const u = await this.$services.sales.getSaleById(payload);
    //     context.commit("setUser", u?.data());
    // },
    // async syncSale(this, context, payload): Promise<void> {
    //     console.log("syncSale:", payload);
    //     const u = await this.$services.sales.syncSale(payload);
    //     context.commit("setSale", u.data());
    // }
};

const catalog: Module<ICatalogState, ICatalogState> = {
    namespaced: true,
    state: {
        loading: true,
    },
    getters,
    mutations,
    actions,
};

export default catalog;
